export const LIST_GETME = 'listGetMe'
export const LIST_CREATE = 'listCreate'
export const LIST_DELETE = 'listDelete'
export const LIST_UPDATE = 'listUpdate'
export const LIST_RELOAD = 'listReload'
